import {GridToolbarContainer, GridToolbarExport} from "@mui/x-data-grid";

export default function customToolbar(fileName) {
    return function() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport csvOptions={{fileName}} printOptions={{ disableToolbarButton: true } }/>
            </GridToolbarContainer>
        );
    }
}
